 import FX from './functions/functions';
import React, { Component}  from 'react';
class Config {
}
Config.options = {
   ui_version: 0.1,
   orders: [{id:"-99", description: "Cancelled"},{id:"0", description:"Awaiting Confirmation"},{id:"1", description:"Error"},{id:"2", description:"Insufficient Stock"},{id:"3", description:"Processing/Waiting for stock"},{id:"10", description:"Processing"},{id:"20", description:"Picking"},{id:"30", description:"Packed"},{id:"40", description:"Partially Dispatched"},{id:"45", description:"Picking Additional"},{id:"50", description:"Completed"}],
   dispatches: [{id:"-99", description: "Cancelled"},{id:"0", description:"Awaiting Confirmation"},{id:"1", description:"Error"},{id:"5", description:"Insufficient Stock"},{id:"10", description:"Processing"},{id:"20", description:"Picking"},{id:"30", description:"Packed"},{id:"40", description:"Partially Dispatched"},{id:"45", description:"Picking Additional"},{id:"50", description:"Dispatched"},{id:"60", description:"Completed"}],
   deliveries: [{id:"-99", description: "Cancelled"},{id:"0", description:"Awaiting Delivery"},{id:"10", description:"Arrived"},{id:"20", description:"Processing"},{id:"51", description:"Received with Discrepancies"},{id:"50", description:"Received"}],
   suppliers: []
}
/*Config.imgHost = 'http://api_xvd/';
Config.utilityHost = 'http://api_xvd/';
Config.apiHost = 'http://api_xvd/v2';*/

Config.imgHost = 'http://api_test.wreningham.com/';
Config.utilityHost = 'http://api_test.wreningham.com/';
Config.apiHost = 'http://api_test.wreningham.com/v2';


Config.panels = ['orders','dispatches','deliveries','products','reports','packing_station'];

Config.tables = {
  orders: {
    str_filter: (obj,filterText) => {
      //console.log(obj);
      var ordRef;
      obj.reference === null ? ordRef = '#No reference' : ordRef = obj.reference;
      return (ordRef.toString().toLowerCase().indexOf(filterText.toLowerCase()) > -1);
    },
    columns : [
      {
        title:'Company',
        field:'company_name',
        show: false
      },
      {
        title:'Name',
        field: 'name',
        display: (item) => {
          var out = '';
          if(item.delivery_address && item.delivery_address.title){
             if(out){
               out += ' ';
             }
             out += item.delivery_address.title;
          }
          if(item.delivery_address && item.delivery_address.forename){
             if(out){
               out += ' ';
             }
            out += item.delivery_address.forename;
          }
          if(item.delivery_address && item.delivery_address.surname){
             if(out){
               out += ' ';
             }
            out += item.delivery_address.surname;
          }
          return out;
       },
        show: true
      },
      {
        title:'Reference',
        field: 'reference',
        show: true
      },
      {
        title:'Order Date',
        field: 'order_date',
        display: (item) => {
            try {
                return FX.dateFormat(item, JSON.parse(window.App.state.user.settings).date_format);
            }
            catch (e){
                console.log(e);
            }
            return FX.dateFormat(item, '{d2}/{m2}/{Y}');
        },
        show: false
      },
      {
        title:'Order Status',
        field: 'order_status',
        display: (item) => {
          var out;
           Config.options.orders.some((opt) => {
              if(parseInt(opt.id,10) === parseInt(item,10)){
                 out = opt.description;
                 return true;
              }
              return false;
           });
           return out;
           },
        show: true
      }
    ],
    click : (app, detail, i) => {
              console.log(detail);
              FX.navigate.bind(app)(app.state.panel, detail.id , '/orders/' + detail.id);
            },
    colourCode : (obj) => {
              if(parseInt(obj.order_status,10) >= 0  && parseInt(obj.order_status,10) < 10){
                return '#d00';
              }
              else if(obj.order_status >= 10 && obj.order_status  < 20 ){
                return '#fd0';
              }
              else if(obj.order_status >= 20 && obj.order_status  < 30 ){
                return '#fd0';
              }
              else if(obj.order_status >= 30 && obj.order_status  < 40 ){
                return '#0b0';
              }
            },
    className : (obj) => {

              if(parseInt(obj.order_status,10) > 0  && parseInt(obj.order_status,10) <= 1){
                return 'error';
              }
              else {
                return '';
              }
            },
     filter: [
      {
        name:'order_status',
        field:'order_status',
        type: 'lookup',
        title: 'Order Status',
        offTitle: 'All Status',
        options: Config.options.orders,
        titleField: 'description',
        active: [],
        test: (value,active) => {
          if (active.length > 0){
            var res = false;
            active.forEach(act => {
              if(parseInt(act,10) === parseInt(value.order_status,10)){
                res= true;
              }
            });
            return res;
          }
          else {
            return true;
          }
        }
      }]
  },
  products: {
    str_filter: (obj,filterText) => {
      return ((obj.sku + obj.name + obj.barcode).toString().toLowerCase().indexOf(filterText.toLowerCase()) > -1);
    },
    columns : [
      {
        title:'SKU',
        field: 'sku',
        show: true
      },
      {
        title:'Name',
        field: 'name',
        show: true
      },
      {
        title:'Barcode',
        field: 'barcode',
        show: true
      },
      {
        title:'Stock',
        field: 'stock',
        display_type: 'object',
        display: (item) => {
           if(item.composite){
              return <i className="material-icons">widgets</i>;
           }
           else if(false && parseInt(item.stock_alloc,10)){
              return item.stock + ' (' + (parseInt(item.stock,10) - parseInt(item.stock_alloc,10)) + ')';
           }
           return item.stock;
        },
        show: true
      },
      {
        title:'Available',
        field: 'stock',
        display_type: 'object',
        display: (item) => {
           if(item.composite){
              return <i className="material-icons">widgets</i>;
           }
           else if(parseInt(item.stock_alloc,10)){
              return  (parseInt(item.stock,10) - parseInt(item.stock_alloc,10));
           }
           return item.stock;
        },
        show: true
      }
    ],
    click : (app, detail, i) => {
              FX.navigate.bind(app)(app.state.panel, detail , '/products/' + detail.id);
            },
    colourCode : (obj) => {
              if(parseInt(obj.order_status,10) === 0){
                return '#d00';
              }
              else if(obj.order_status >= 10 && obj.order_status  < 20 ){
                return '#fd0';
              }
              else if(obj.order_status >= 20 && obj.order_status  < 30 ){
                return '#fd0';
              }
              else if(obj.order_status >= 30 && obj.order_status  < 40 ){
                return '#0b0';
              }
            },
     filter: [
      {
        name:'archive_1',
        field:'archive',
        type: 'switch',
        title: 'Archive',
        offTitle: 'All Status',
        options: [{id: 0, description:'Unarchived' },{id: 1, description:'Archived' }],
        titleField: 'description',
        active: [],
        test: (value, active) => {
        if(active.length)
          return active.map(Number).includes(parseInt(value.archive, 10));
          return true;
        }
      },
      {
        name:'archive_2',
        field:'archive',
        type: 'switch',
        title: 'Archive',
        offTitle: 'All Status',
        options: [{id: 0, description:'Unarchived' },{id: 1, description:'Archived' }],
        titleField: 'description',
        active: [],
        test: (value, active) => {
        if(active.length)
          return active.map(Number).includes(parseInt(value.archive, 10));
          return true;
        }
      },
      {
        name:'supplier_id',
        field:'supplier_id',
        type: 'lookup',
        title: 'Suppliers',
        offTitle: 'All Suppliers',
        options: "suppliers",
        active: [],
        titleField: 'name',
        test: (value,active) => {
          if (active.length > 0){
            var res = false;
            active.forEach(act => {
                value.supplier_link.forEach( sup => {
                    if(parseInt(act,10) === parseInt(sup.supplier_id,10)){
                      res= true;
                    }
                });
            });
            return res;
          }
          else {
            return true;
          }
        }
      },
      {
        name:'product_set_id',
        field:'product_set_id',
        type: 'lookup',
        title: 'Product Sets',
        offTitle: 'All Products',
        options: "product_sets",
        active: [],
        titleField: 'name',
        test: (value,active) => {
          if (active.length > 0){
            var res = false;
            active.forEach(act => {
                value.product_set_link.forEach( ps => {
                    if(parseInt(act,10) === parseInt(ps.product_set_id,10)){
                      res= true;
                    }
                });
            });
            return res;
          }
          else {
            return true;
          }
        }
      }





      ]
  },
  dispatches: {
    str_filter: (obj,filterText) => {
      return (obj.reference.toLowerCase().indexOf(filterText.toLowerCase()) > -1);
    },
    columns : [
      {
        title:'Company',
        field:'company_name',
        show: false
      },
      {
        title:'Name',
        field: 'name',
        display: (item) => {
          var out = '';
          if(item.delivery_address.title){
             if(out){
               out += ' ';
             }
             out += item.delivery_address.title;
          }
          if(item.delivery_address.forename){
             if(out){
               out += ' ';
             }
            out += item.delivery_address.forename;
          }
          if(item.delivery_address.surname){
             if(out){
               out += ' ';
             }
            out += item.delivery_address.surname;
          }
          //out = item.delivery_address.forename.toString() + ' ' + item.delivery_address.surname.toString();
          return out;
        },
        show: true
      },
      {
        title:'Reference',
        field: 'reference',
        show: true
      },
      {
        title:'Dispatch Date',
        field: 'dispatch_date',
        display: (item) => {
            try {
                return FX.dateFormat(item, JSON.parse(window.App.state.user.settings).date_format);
            }
            catch (e){
                console.log(e);
            }
            return FX.dateFormat(item, '{d2}/{m2}/{Y}');
        },
        show: false
      },
      {
        title:'Dispatch Status',
        field: 'dispatch_status',
        display: (item) => {
          var out;
           Config.options.dispatches.some((opt) => {
              //console.log(parseInt(opt.id,10));
              //console.log(item);
              //console.log(parseInt(item ,10));
              if(parseInt(opt.id,10) === parseInt(item,10)){
                 out = opt.description;
                 return true;
              }
              return false;
           });
           return out;
           },
        show: true
      },
      {
        title:'Tracking Code',
        field: 'trackng_code',
        display: (item) => {
              if(item.consignment && item.consignment.tracking_code){
                 return item.consignment.tracking_code;
              }
           },
        show: true
      }
    ],
    click : (app, detail, i) => {
              FX.navigate.bind(app)(app.state.panel, detail.id , '/dispatches/' + detail.id);
            },
    colourCode : (obj) => {
              if(parseInt(obj.dispatch_status,10) >= 0  && parseInt(obj.dispatch_status,10) < 10){
                return '#d00';
              }
              else if(obj.dispatch_status >= 10 && obj.dispatch_status  < 20 ){
                return '#fd0';
              }
              else if(obj.dispatch_status >= 20 && obj.dispatch_status  < 30 ){
                return '#fd0';
              }
              else if(obj.dispatch_status >= 30 && obj.dispatch_status  < 40 ){
                return '#0b0';
              }
            },
     filter: []
  },
  deliveries: {
    str_filter: (obj,filterText) => {
      if(obj.reference){
        console.log(obj.reference.indexOf(filterText));
        return (obj.reference.toLowerCase().indexOf(filterText.toLowerCase()) > -1);
       }
       else {
         return false;
       }
    },
    columns : [
      {
        title:'Reference',
        field:'reference',
        show: true
      },
      {
        title:'Expected Delivery Date',
        field: 'expected_delivery_date',
        display: (item) => {
            try {
                return FX.dateFormat(item, JSON.parse(window.App.state.user.settings).date_format);
            }
            catch (e){
                //console.log(e);
            }
            return FX.dateFormat(item, '{d2}/{m2}/{Y}');
           },
        show: true
      },
      {
        title:'Arrived Date',
        field: 'arrived_date',
        display: (item) => {
            try {
                return FX.dateFormat(item, JSON.parse(window.App.state.user.settings).date_format);
            }
            catch (e){
                //console.log(e);
            }
            return FX.dateFormat(item, '{d2}/{m2}/{Y}');
           },
        show: true
      },
      {
        title:'Processing Start Date',
        field: 'processing_date',
        display: (item) => {
            try {
                return FX.dateFormat(item, JSON.parse(window.App.state.user.settings).date_format);
            }
            catch (e){
                //console.log(e);
            }
            return FX.dateFormat(item, '{d2}/{m2}/{Y}');
        },
        show: true
      },
      {
        title:'Received Date',
        field: 'received_date',
        display: (item) => {
            try {
                return FX.dateFormat(item, JSON.parse(window.App.state.user.settings).date_format);
            }
            catch (e){
                //console.log(e);
            }
            return FX.dateFormat(item, '{d2}/{m2}/{Y}');
           },
        show: true
      },
      {
        title:'Supplier',
        field: 'supplier',
        display: (item) => {
          var out;
           Config.options.suppliers.some((opt) => {
              if(parseInt(opt.id,10) === parseInt(item.supplier_id,10)){
                 out = opt.name;
                 return true;
              }
              return false;
           });
           return item.name;
           },
        show: true

      },
      {
        title:'Status',
        field: 'delivery_status',
        display: (item) => {
          var out;
           Config.options.deliveries.some((opt) => {
              //console.log(parseInt(opt.id,10));
              //console.log(item);
              //console.log(parseInt(item ,10));
              if(parseInt(opt.id,10) === parseInt(item ,10)){
                 out = opt.description;
                 return true;
              }
              return false;
           });
           return out;
        },
        show: true

      }
    ],
    click: (app, detail, i) => {
              FX.navigate.bind(app)(app.state.panel, detail.id , '/deliveries/' + detail.id);
            },
    colourCode: (obj) => {
              if(obj.delivery_status >= 0 && obj.delivery_status  < 10 ){
                return '#d00';
              }
              else if(obj.delivery_status >= 10 && obj.delivery_status  < 20 ){
                return '#dd0';
              }
              else if(obj.delivery_status >= 20 && obj.delivery_status  < 30 ){
                return '#fd0';
              }
              else if(obj.delivery_status == 51){
                return '#396';
              }
              else if(obj.delivery_status == 50 ){
                return '#0d0';
              }
            },
     filter: [
      {
        name:'delivery_status',
        field:'delivery_status',
        type: 'lookup',
        title: 'Delivery Status',
        offTitle: 'All Status',
        options: Config.options.deliveries,
        titleField: 'description',
        active: [],
        test: (value,active) => {
          if (active.length > 0){
            var res = false;
            active.forEach(act => {
              if(parseInt(act,10) === parseInt(value.delivery_status,10)){
                res= true;
              }
            });
            return res;
          }
          else {
            return true;
          }
        }
      },
      {
        name:'supplier_id',
        field:'supplier_id',
        type: 'lookup',
        title: 'Suppliers',
        offTitle: 'All Suppliers',
        options: "suppliers",
        active: [],
        titleField: 'name',
        test: (value,active) => {
          if (active.length > 0){
            var res = false;
            active.forEach(act => {
              if(parseInt(act,10) === parseInt(value.supplier_id,10)){
                res= true;
              }
            });
            return res;
          }
          else {
            return true;
          }
        }
      },
      ]
  }
};
export default Config;



// WEBPACK FOOTER //
// ./src/Config.js